import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'collab.public',
    path: 'projects',
    name: 'ProjectPublicBrowse',
    component: () => import('./PgC0101List'),
    meta: {}
  },
  {
    portalGroup: 'collab.public',
    path: 'projects/:id',
    name: 'ProjectPublicRead',
    component: () => import('./PgC0101View'),
    meta: { title: i18n.t('c0101.read.title') }
  },
  {
    portalGroup: 'collab.my',
    path: 'projects',
    name: 'ProjectMyBrowse',
    component: () => import('./PgC0101MultiPage'),
    meta: { title: i18n.t('c0101.browse.title'), authenticated: true }
  },
  {
    portalGroup: 'collab.my',
    path: 'projects/:id/edit',
    name: 'ProjectMyEdit',
    component: () => import('./PgC0101Form'),
    meta: { title: i18n.t('c0101.edit.title'), authenticated: true }
  },
  {
    portalGroup: 'collab.admin',
    path: 'projects/:id/review',
    name: 'ProjectAdminReview',
    component: () => import('./PgC0101FormReview'),
    meta: {}
  },
  {
    portalGroup: 'collab.admin',
    path: 'projects',
    name: 'ProjectAdminBrowse',
    component: () => import('./PgC0101MultiPage'),
    meta: { title: i18n.t('c0101.browse.title'), authenticated: true }
  }
]
